import {
  AuthActionTypes,
  DoNotShowMeAgain,
  FilledInvite,
  InviteInfo,
  InviteToken,
  LoginAttempt,
  NewDistrictRegistrationCredential,
  OnboardingStates,
  RegistrationDistrict,
  UserCredential,
  UserInfo,
  UserRegistrationCredential,
} from "./types";
import { action } from "typesafe-actions";
import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { Dispatch } from "redux";
import {
  API_ACCEPT_INVITE,
  API_AUTH_URL,
  API_CHANGE_PASSWORD,
  API_CHANGE_PASSWORD_BY_TOKEN,
  API_COACH_TRIAL_REGISTRATION,
  API_DISTRICT_TRIAL_REGISTRATION,
  API_INVITE_INFO,
  API_LOGOUT,
  API_REGISTRATION_DISTRICTS,
  API_RESEND_OTP,
  API_RESET_PASSWORD,
  API_TOKEN_VALIDATION,
  API_UPDATE_DO_NOT_SHOW_ME,
  API_UPDATE_USER_ONBOARDING_STEP,
  API_UPLOAD_USER_PROFILE_IMAGE,
  API_USER_INFO,
  API_USER_PROFILE,
  API_USER_REGISTRATION,
  API_VERIFY_OTP,
} from "../../constants";
import { ApplicationState, history } from "../index";
import { push } from "connected-react-router";
import { toastr } from "react-redux-toastr";
import { SessionStorageKeys } from "../../utils/LocalStorageUtils";

export const requestLogin = (user: UserCredential) =>
  action(AuthActionTypes.LOGIN, { user });
export const receiveLogin = (user?: UserCredential) =>
  action(AuthActionTypes.LOGIN_SUCCESS, { user });
export const loginError = (errorResponse: any) =>
  action(AuthActionTypes.LOGIN_FAILURE, { error: errorResponse });
export const loginAttempts = (loginAttemptObj: LoginAttempt) =>
  action(AuthActionTypes.LOGIN_ATTEMPTS, loginAttemptObj);
export const resetLoginAttempts = () =>
  action(AuthActionTypes.RESET_LOGIN_ATTEMPTS);
export const logout = () => action(AuthActionTypes.LOGOUT);

export const redirectToVerifyOtp = (userName: string) =>
  action(AuthActionTypes.REDIRECT_TO_VERIFY_OTP, { userName });

export const loadUserInfoRequest = () =>
  action(AuthActionTypes.LOAD_USER_INFO_START);
export const loadUserInfoSuccess = (userInfo: UserInfo) =>
  action(AuthActionTypes.LOAD_USER_INFO_SUCCESS, { userInfo });
export const loadUserInfoFailure = (message: string) =>
  action(AuthActionTypes.LOAD_USER_INFO_FAILURE, { error: message });

export const registerUserRequest = () =>
  action(AuthActionTypes.REGISTER_USER_START);
export const registerUserSuccess = () =>
  action(AuthActionTypes.REGISTER_USER_SUCCESS);
export const registerUserFailure = (message: string) =>
  action(AuthActionTypes.REGISTER_USER_FAILURE, { error: message });

export const registerNewDistrictRequest = () =>
  action(AuthActionTypes.REGISTER_USER_START);
export const registerNewDistrictSuccess = () =>
  action(AuthActionTypes.REGISTER_USER_SUCCESS);
export const registerNewDistrictFailure = (message: string) =>
  action(AuthActionTypes.REGISTER_USER_FAILURE, { error: message });

export const loadRegistrationDistrictsRequest = () =>
  action(AuthActionTypes.LOAD_REGISTRATION_DISTRICTS_START);
export const loadRegistrationDistrictsSuccess = (
  districts: Array<RegistrationDistrict>
) => action(AuthActionTypes.LOAD_REGISTRATION_DISTRICTS_SUCCESS, { districts });
export const loadRegistrationDistrictsFailure = (message: string) =>
  action(AuthActionTypes.LOAD_REGISTRATION_DISTRICTS_FAILURE, {
    error: message,
  });

export const uploadUserProfileImageRequest = () =>
  action(AuthActionTypes.UPLOAD_USER_PROFILE_IMAGE_START);
export const uploadUserProfileImageSuccess = (image: string) =>
  action(AuthActionTypes.UPLOAD_USER_PROFILE_IMAGE_SUCCESS, { image });
export const uploadUserProfileImageFailure = (message: string) =>
  action(AuthActionTypes.UPLOAD_USER_PROFILE_IMAGE_FAILURE, {
    error: message,
  });

export const updateUserOnboardingStepRequest = () =>
  action(AuthActionTypes.UPDATE_USER_ONBOARDING_STEP_START);
export const updateUserOnboardingStepSuccess = (
  onboardingState: OnboardingStates
) =>
  action(AuthActionTypes.UPDATE_USER_ONBOARDING_STEP_SUCCESS, {
    onboardingState,
  });
export const updateUserOnboardingStepFailure = (message: string) =>
  action(AuthActionTypes.UPDATE_USER_ONBOARDING_STEP_FAILURE, {
    error: message,
  });

export const changePasswordRequest = () =>
  action(AuthActionTypes.CHANGE_PASSWORD_START);
export const changePasswordSuccess = () =>
  action(AuthActionTypes.CHANGE_PASSWORD_SUCCESS);
export const changePasswordFailure = (message: string) =>
  action(AuthActionTypes.CHANGE_PASSWORD_FAILURE, {
    error: message,
  });

export const tokenValidRequest = () =>
  action(AuthActionTypes.TOKEN_VALID_START);
export const tokenValidSuccess = () =>
  action(AuthActionTypes.TOKEN_VALID_SUCCESS);
export const tokenValidFailure = (message: string) =>
  action(AuthActionTypes.TOKEN_VALID_FAILURE, {
    error: message,
  });

export const openEditProfileModal = () =>
  action(AuthActionTypes.OPEN_EDIT_PROFILE_MODAL);
export const hideEditProfileModal = () =>
  action(AuthActionTypes.HIDE_EDIT_PROFILE_MODAL);

export const updateProfileRequest = () =>
  action(AuthActionTypes.UPDATE_PROFILE_START);
export const updateProfileSuccess = (userInfo: UserInfo) =>
  action(AuthActionTypes.UPDATE_PROFILE_SUCCESS, {
    userInfo,
  });
export const updateProfileFailure = (message: string) =>
  action(AuthActionTypes.UPDATE_PROFILE_FAILURE, {
    error: message,
  });

export const patchProfileRequest = () =>
  action(AuthActionTypes.PATCH_PROFILE_START);
export const patchProfileSuccess = (userInfo: UserInfo) =>
  action(AuthActionTypes.PATCH_PROFILE_SUCCESS, { userInfo });
export const patchProfileFailure = (message: string) =>
  action(AuthActionTypes.PATCH_PROFILE_FAILURE, {
    error: message,
  });

export const getInviteInfoRequest = () =>
  action(AuthActionTypes.GET_INVITE_INFO_START);
export const getInviteInfoSuccess = (inviteInfo: InviteInfo) =>
  action(AuthActionTypes.GET_INVITE_INFO_SUCCESS, { inviteInfo });
export const getInviteInfoFailure = (message: string) =>
  action(AuthActionTypes.GET_INVITE_INFO_FAILURE, { error: message });

export const acceptInviteRequest = () =>
  action(AuthActionTypes.ACCEPT_INVITE_START);
export const acceptInviteSuccess = () =>
  action(AuthActionTypes.ACCEPT_INVITE_SUCCESS);
export const acceptInviteFailure = (message: string) =>
  action(AuthActionTypes.ACCEPT_INVITE_FAILURE, { error: message });

export const loginUser = (user: UserCredential) => {
  return (dispatch: Dispatch<any>) => {
    dispatch(requestLogin(user));
    const data = JSON.stringify(user);
    //const prevUrl = (history.location.state as any)?.from?.pathname;
    return axios
      .post(API_AUTH_URL, data)
      .then((res) => {
        const responseData = res.data;
        // Check if OTP is required
        if (responseData.password_success && responseData.tempToken  && responseData.mfaEnable) {
          sessionStorage.setItem('tempToken', responseData.tempToken);
          toastr.success('Success','OTP has been sent to your email.');
          dispatch(push('/verify-otp/true'));
          dispatch(redirectToVerifyOtp(user.username));
          return;
        } else {
          // Normal login flow without OTP
          sessionStorage.setItem('loginStatus','true');
          dispatch(receiveLogin(user));
          return dispatch(getUserInfo());
        }
        
      })
      .catch((err: AxiosError) => {
        if(err.response?.status == 429) { //Too Many Requests
          let  loginAttemptResponse = err.response.data as LoginAttempt;
          dispatch(loginAttempts(loginAttemptResponse));
          return;
        } else if(err.response?.status == 423) { //user locked / disabled 
          dispatch(loginError({
            message: (err.response?.data as { error: string }).error, 
            isDisabled: true,
            isOtpLocked: (err.response?.data as { otp_locked: boolean }).otp_locked,
            remainingLockTime: (err.response?.data as { remaining_lock_time: number }).remaining_lock_time
          }));
        } else {
          if(err.response && (err.response?.data as { remaining_attempt: number }).remaining_attempt) {
            dispatch(loginError({message: err.message, remainingAttempt: (err.response?.data as { remaining_attempt: number }).remaining_attempt}));
          } else {
            dispatch(loginError({message: err.message, remainingAttempt: 0}));
          }
        }
      })
      .then(() => {
        // if (prevUrl) {
        //   dispatch(push(prevUrl));
        // }
      });
  };
};

export const logoutUser = () => {
  return (dispatch: Dispatch) => {
    return axios
      .post(API_LOGOUT)
      .then(() => {
        // Clear session storage for loaded evidence data
        Object.keys(sessionStorage).forEach(key => {
          if (key.startsWith(SessionStorageKeys.LoadedEvidenceData)) {
            sessionStorage.removeItem(key);
          }
        });
        
        dispatch(logout());
        dispatch({ type: "RESET_APP" });
      })
      .catch((err: AxiosError) => {
        if (err.response?.status === 403) {
          // Clear session storage on error too
          Object.keys(sessionStorage).forEach(key => {
            if (key.startsWith(SessionStorageKeys.LoadedEvidenceData)) {
              sessionStorage.removeItem(key);
            }
          });
          
          dispatch(logout());
          dispatch({ type: "RESET_APP" });
        }
        toastr.error("Failed to logout", err.message);
      });
  };
};

export const registerUser = (user: UserRegistrationCredential) => {
  return (dispatch: Dispatch) => {
    dispatch(registerUserRequest());
    return axios
      .post(API_USER_REGISTRATION, user)
      .then(() => {
        dispatch(registerUserSuccess());
        const newUser = { username: user.email, password: user.password };
        loginUser(newUser)(dispatch);
      })
      .catch((err: AxiosError) => {
        if (err.response && (err.response?.data as { email: string }).email) {
          dispatch(
            registerUserFailure(
              "The email you entered is invalid or already registered."
            )
          );
        } else {
          dispatch(registerUserFailure(err.message));
        }
      });
  };
};

export const registerNewDistrict = (
  user: NewDistrictRegistrationCredential,
  trialType: "coach" | "district"
) => {
  return (dispatch: Dispatch<any>) => {
    dispatch(registerUserRequest());
    const registerUrl =
      trialType === "district"
        ? API_DISTRICT_TRIAL_REGISTRATION
        : API_COACH_TRIAL_REGISTRATION;
    return axios
      .post(registerUrl, user)
      .then(() => {
        dispatch(registerUserSuccess());
        toastr.success("Success", "The new district has been successfully registered.")
        return Promise.resolve(1);
        // const newUser = { username: user.email, password: user.password };
        // loginUser(newUser)(dispatch);
      })
      .catch((err: AxiosError) => {
        let errorMessage = err.message;
        const data = err.response?.data as any;

        if (data) {
          if (Array.isArray(data.non_field_errors) && data.non_field_errors.length) {
            errorMessage = data.non_field_errors[0];
          } else if (Array.isArray(data.password) && data.password.length) {
            errorMessage = data.password[0];
          } else if (Array.isArray(data.password_confirmation) && data.password_confirmation.length) {
            errorMessage = data.password_confirmation[0];
          } else if (Array.isArray(data.email) && data.email.length) {
            errorMessage = data.email[0];
          } else if (typeof data.error === "string" && data.error) {
            errorMessage = data.error;
          }
        }

        dispatch(registerUserFailure(errorMessage));
      });
  };
};

export const resetNewDistrictBool = () => 
  action(AuthActionTypes.RESET_NEW_DISTRICT_BOOL);

export const getInviteInfo = (inviteToken: InviteToken) => {
  return (dispatch: Dispatch) => {
    dispatch(getInviteInfoRequest());
    return axios
      .get(API_INVITE_INFO(inviteToken))
      .then((res) => {
        const inviteInfo: InviteInfo = res.data;
        dispatch(getInviteInfoSuccess(inviteInfo));
      })
      .catch((err: AxiosError) => {
        dispatch(getInviteInfoFailure(err.message));
      });
  };
};

export const acceptInvite = (filledInvite: FilledInvite) => {
  return (dispatch: Dispatch) => {
    dispatch(acceptInviteRequest());
    return axios
      .put(API_ACCEPT_INVITE, filledInvite)
      .then(() => {
        dispatch(acceptInviteSuccess());
      })
      .catch((err: AxiosError) => {
        let errorMessage = err.message;
        const data = err.response?.data as any;

        if (data) {
          if (Array.isArray(data.non_field_errors) && data.non_field_errors.length) {
            errorMessage = data.non_field_errors[0];
          } else if (Array.isArray(data.password) && data.password.length) {
            errorMessage = data.password[0];
          } else if (Array.isArray(data.password_confirmation) && data.password_confirmation.length) {
            errorMessage = data.password_confirmation[0];
          } else if (Array.isArray(data.email) && data.email.length) {
            errorMessage = data.email[0];
          } else if (typeof data.error === "string" && data.error) {
            errorMessage = data.error;
          }
        }

        dispatch(acceptInviteFailure(errorMessage));
      });
  };
};

export const getUserInfo = () => {
  return (dispatch: Dispatch<any>, getState: () => ApplicationState) => {
    dispatch(loadUserInfoRequest());
    return axios
      .get(API_USER_INFO)
      .then((res) => {
        const userInfo: UserInfo = res.data;
        if (
          !getState().auth.userInfo ||
          userInfo.id === getState().auth.userInfo?.id
        ) {
          dispatch(loadUserInfoSuccess(userInfo));
        } else {
          dispatch(logoutUser());
        }
      })
      .catch((err: AxiosError) => {
        dispatch(loadUserInfoFailure(err.message));
      });
  };
};

export const getRegistrationDistricts = () => {
  return (dispatch: Dispatch) => {
    dispatch(loadRegistrationDistrictsRequest());
    return axios
      .get(API_REGISTRATION_DISTRICTS)
      .then((res) => {
        const registrationDistricts: Array<RegistrationDistrict> = res.data;
        dispatch(loadRegistrationDistrictsSuccess(registrationDistricts));
      })
      .catch((err: AxiosError) => {
        dispatch(loadRegistrationDistrictsFailure(err.message));
      });
  };
};

export const uploadUserProfileImage = (file: File) => {
  return (dispatch: Dispatch<any>, getState: () => ApplicationState) => {
    dispatch(uploadUserProfileImageRequest());
    const formData = new FormData();
    formData.append("profile_image", file);
    const config: AxiosRequestConfig = {
      headers: {
        "content-type": file.type,
      },
    };
    return axios
      .put(
        API_UPLOAD_USER_PROFILE_IMAGE(getState().auth.userInfo!.id),
        formData,
        config
      )
      .then((res) => {
        const image: string = res.data.profile_image_url;
        dispatch(uploadUserProfileImageSuccess(image));
      })
      .catch((err: AxiosError) => {
        dispatch(uploadUserProfileImageFailure(err.message));
      });
  };
};

export const updateUserOnboardingStep = () => {
  return (dispatch: Dispatch, getState: () => ApplicationState) => {
    dispatch(updateUserOnboardingStepRequest());
    const userInfo = getState().auth.userInfo;
    if (!userInfo) return dispatch(push("/onboarding"));
    return axios
      .put(API_UPDATE_USER_ONBOARDING_STEP(userInfo.profile.onboarding_state))
      .then((res) => {
        const new_onboarding_state: OnboardingStates =
          res.data.new_onboarding_state;
        dispatch(updateUserOnboardingStepSuccess(new_onboarding_state));
        dispatch(push("/onboarding"));
      })
      .catch((err: AxiosError) => {
        dispatch(updateUserOnboardingStepFailure(err.message));
      });
  };
};

export const changePassword = (
  current_password: string,
  new_password: string,
  new_password_confirmation: string
) => {
  return (dispatch: Dispatch<any>) => {
    dispatch(changePasswordRequest());
    return axios
      .post(API_CHANGE_PASSWORD(), {
        current_password,
        new_password,
        new_password_confirmation,
      })
      .then(() => {
        toastr.success("Success", "The password has been successfully updated. Please login again with the new password.",{
          timeOut: 3000,
          onHideComplete: () => {
            dispatch(changePasswordSuccess());
            dispatch(logoutUser());
            // window.location.reload();
          }
        });
      })
      .catch((err: AxiosError) => {
        let errorMessage = err.message;
        const data: any = err.response?.data;

      if (data?.non_field_errors) {
        errorMessage = data.non_field_errors[0];
      }
        dispatch(changePasswordFailure(errorMessage));
      });
  };
};

export const changePasswordByToken = (
  token: string,
  email: string,
  password: string
) => {
  return (dispatch: Dispatch) => {
    dispatch(changePasswordRequest());
    return axios
      .post(API_CHANGE_PASSWORD_BY_TOKEN, {
        token: token,
        email: email,
        password: password,
      })
      .then(() => {
        dispatch(changePasswordSuccess());
      })
      .catch((err: AxiosError) => {
        if (err.response && err.response.status === 400) {
          const responseData = err.response.data as any;
          if (Object.prototype.hasOwnProperty.call(responseData, "error")) {
            dispatch(changePasswordFailure(responseData?.error));
            return Promise.reject(responseData?.error);
          } else {
            const passErrors: Array<string> = (err.response?.data as { password: string[] }).password || [];
            dispatch(changePasswordFailure(passErrors.join(" ")));
            return Promise.reject(passErrors.join(" "));
          }
        } else {
          dispatch(changePasswordFailure(err.message));
          return Promise.reject(err.message);
        }
      });
  };
};

export const isTokenValid = (
  token: string,
  email: string,
) => {
  return (dispatch: Dispatch) => {
    dispatch(tokenValidRequest());
    return axios
      .get(API_TOKEN_VALIDATION(token,email))
      .then(() => {
        dispatch(tokenValidSuccess());
      })
      .catch((err: AxiosError) => {
        const responseData = err.response?.data as any;
        dispatch(tokenValidFailure(responseData?.error));
        return Promise.reject(responseData?.error);
      });
  };
};

export const updateProfile = (userInfo: UserInfo) => {
  return (dispatch: Dispatch) => {
    dispatch(updateProfileRequest());
    return axios
      .put(API_USER_INFO, {
        userInfo,
      })
      .then((res) => {
        const userInfo: UserInfo = res.data;
        dispatch(updateProfileSuccess(userInfo));
      })
      .catch((err: AxiosError) => {
        dispatch(updateProfileFailure(err.message));
      });
  };
};

export const patchProfile = (
  userId: number,
  request: { agreed_to_data_sharing?: boolean }
) => {
  return (dispatch: Dispatch) => {
    dispatch(patchProfileRequest());
    return axios
      .patch(API_USER_PROFILE(userId), request)
      .then((res) => {
        const userInfo: UserInfo = res.data;
        dispatch(patchProfileSuccess(userInfo));
      })
      .catch((err: AxiosError) => {
        dispatch(patchProfileFailure(err.message));
      });
  };
};

export const resetPasswordRequest = () =>
  action(AuthActionTypes.RESET_PASSWORD_START);
export const resetPasswordSuccess = (responseData: any) =>
  action(AuthActionTypes.RESET_PASSWORD_SUCCESS, {responseData});
export const resetPasswordFailure = (message: string) =>
  action(AuthActionTypes.RESET_PASSWORD_FAILURE, {
    error: message,
  });

export const resetPassword = (email: string) => {
  return (dispatch: Dispatch) => {
    dispatch(resetPasswordRequest());
    return axios
      .post(API_RESET_PASSWORD, {
        email,
      })
      .then((response) => {
        dispatch(resetPasswordSuccess(response.data));
      })
      .catch((err: AxiosError) => {
        dispatch(resetPasswordFailure(err.message));
        return Promise.reject(err.message);
      });
  };
};

export const updateDoNotShowMeAgainRequest = () =>
  action(AuthActionTypes.UPDATE_DO_NOT_SHOW_START);
export const updateDoNotShowMeAgainSuccess = (responseData: any) =>
  action(AuthActionTypes.UPDATE_DO_NOT_SHOW_SUCCESS, {responseData});
export const updateDoNotShowMeAgainFailure = (message: string) =>
  action(AuthActionTypes.UPDATE_DO_NOT_SHOW_FAILURE, {
    error: message,
  });

export const updateDoNotShowMeAgain = (doNotShowMeAgain: DoNotShowMeAgain) => {
  return (dispatch: Dispatch) => {
    dispatch(updateDoNotShowMeAgainRequest());
    return axios
      .post(API_UPDATE_DO_NOT_SHOW_ME, doNotShowMeAgain)
      .then((response) => {
        const doNotShowMeRes: DoNotShowMeAgain = response.data;
        dispatch(updateDoNotShowMeAgainSuccess(doNotShowMeRes));
      })
      .catch((err: AxiosError) => {
        dispatch(updateDoNotShowMeAgainFailure(err.message));
        return Promise.reject(err.message);
      });
  };
};

export const groupReorderUpdateRequest = () =>
  action(AuthActionTypes.GROUP_REORDER_UPDATE_START);
export const groupReorderUpdateSuccess = (userInfo: UserInfo) =>
  action(AuthActionTypes.GROUP_REORDER_UPDATE_SUCCESS, {
    userInfo,
  });
export const groupReorderUpdateFailure = (message: string) =>
  action(AuthActionTypes.GROUP_REORDER_UPDATE_FAILURE, {
    error: message,
  });

export const groupReorderUpdate = (userInfo: UserInfo) => {
  return (dispatch: Dispatch<any>) => {
    dispatch(groupReorderUpdateRequest());
    return axios
      .put(API_USER_INFO, {
        userInfo,
      })
      .then((res) => {
        const userInfo: UserInfo = res.data;
        dispatch(groupReorderUpdateSuccess(userInfo));
        return Promise.resolve(userInfo);
      })
      .catch((err: AxiosError) => {
        dispatch(groupReorderUpdateFailure(err.message));
        return Promise.reject(err.message);
      });
  };
};

// OTP Actions
export const verifyOtpRequest = () =>
  action(AuthActionTypes.VERIFY_OTP_START);
export const verifyOtpSuccess = () =>
  action(AuthActionTypes.VERIFY_OTP_SUCCESS);
export const verifyOtpFailure = (error: {loginSuccess: boolean; remainingAttempts?: number; isOtpExpired?: boolean; lockTime?: number; isOtpLocked?: boolean }) =>
  action(AuthActionTypes.VERIFY_OTP_FAILURE, { error });

export const resendOtpRequest = () =>
  action(AuthActionTypes.RESEND_OTP_START);
export const resendOtpSuccess = () =>
  action(AuthActionTypes.RESEND_OTP_SUCCESS);
export const resendOtpFailure = (error: {resendSuccess: boolean; isOtpExpired?: boolean }) =>
  action(AuthActionTypes.RESEND_OTP_FAILURE, { error });

export const verifyOtp = (otp: string, tempToken: string) => {
  return (dispatch: Dispatch<any>) => {
    dispatch(verifyOtpRequest());
    return axios
      .post(API_VERIFY_OTP, { otp, tempToken })
      .then((res) => {
        const response = res.data;
        if (response.login_success) {
          sessionStorage.setItem('loginStatus', 'true');
          sessionStorage.removeItem('tempToken');
          // Load user info first, then dispatch verifyOtpSuccess after it completes
          return dispatch(getUserInfo() as any).then(() => {
            return dispatch(verifyOtpSuccess());
          });
        } else {
          dispatch(verifyOtpFailure({
            loginSuccess: response.login_success,
            remainingAttempts: response.remaining_attempts,
            ...(response.isExpired ? { isOtpExpired: response.isExpired } : {}),
            ...(response.lock_time ? { lockTime: response.lock_time } : {}),
            ...(response.otp_locked ? { isOtpLocked: response.otp_locked } : {})
          }));
          //return Promise.reject(response);
        }
      })
      .catch((err: AxiosError) => {
        const errorData = err.response?.data as any;
        const errorObject = {
          loginSuccess: errorData?.login_success || false,
          remainingAttempts: errorData?.remaining_attempts,
          ...(errorData?.isExpired ? { isOtpExpired: errorData.isExpired } : {}),
          ...(errorData?.lock_time ? { lockTime: errorData.lock_time } : {}),
          ...(errorData?.otp_locked ? { isOtpLocked: errorData.otp_locked } : {})
        };
        dispatch(verifyOtpFailure(errorObject));
        //return Promise.reject(err);
      });
  };
};

export const resendOtp = (tempToken: string) => {
  return (dispatch: Dispatch) => {
    dispatch(resendOtpRequest());
    return axios
      .post(API_RESEND_OTP, { tempToken })
      .then((res) => {
        const response = res.data;
        if (response.resend_success) {
          dispatch(resendOtpSuccess());
          toastr.success('Success', 'OTP has been resent to your email');
        } else {
          dispatch(resendOtpFailure({
            resendSuccess: response.resend_success,
            ...(response.isExpired ? { isOtpExpired: response.isExpired } : {})
          }));
        }
      })
      .catch((err: AxiosError) => {
        const errorData = err.response?.data as any;
        const errorObject = {
          resendSuccess: errorData?.resend_success,
          ...(errorData?.isExpired ? { isOtpExpired: errorData.isExpired } : {})
        };
        dispatch(resendOtpFailure(errorObject));
      });
  };
};

export const backToLogin = () =>
  action(AuthActionTypes.BACK_TO_LOGIN);
